import clsx from 'clsx';
import styles from './index.module.scss';

export interface MobileFormInputProps {
  formik: any;
  name: string;
  className?: string;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
}

function MobileFormInput(props: MobileFormInputProps) {
  const error = props.formik?.errors[props.name];
  //const isToched = props.formik?.touched[props.name];

  return (
    <div className={clsx(styles.root, props.className)}>
      <input
        className={clsx({
          [styles.input]: true,
          [styles.withError]: !!error,
        })}
        name={props.name}
        onChange={props.formik?.handleChange}
        {...props.inputProps}
      />
      <span className={styles.errorText}>
        {props.formik.errors[props.name] || <>&nbsp;</>}
      </span>
    </div>
  );
}

export default MobileFormInput;
